import React, {useState} from "react"
import {Box, Button, Collapse, Typography} from "@mui/material"

function MessageBody({body, quoted}: {body: string; quoted: string | null}) {
	const [showQuoted, setShowQuoted] = useState(false)

	return (
		<>
			{body && (
				<Typography
					variant="body2"
					color="textPrimary"
					mt={1.5}
					sx={{whiteSpace: "pre-wrap", maxWidth: "80ch", lineHeight: 1.65}}
				>
					{body}
				</Typography>
			)}
			{quoted && (
				<Box mt={1}>
					<Button variant="text" size="small" onClick={() => setShowQuoted((shown) => !shown)}>
						{showQuoted ? "Hide quoted text" : "Show quoted text"}
					</Button>
					<Collapse in={showQuoted} unmountOnExit>
						<Typography
							variant="body2"
							color="textSecondary"
							sx={{
								whiteSpace: "pre-wrap",
								borderLeft: "2px solid",
								borderColor: "grey.200",
								pl: 1.5,
								mt: 0.5,
							}}
						>
							{quoted}
						</Typography>
					</Collapse>
				</Box>
			)}
		</>
	)
}

export {MessageBody}
